import { graphql } from "@/gql";

export const CHECK_IN_REPORT_QUERY = graphql(`
  query CHECK_IN_REPORT_QUERY($id: String!) {
    checkInReport(id: $id) {
      id
      organizationId
      shortId
      createdAt
      requestorMember {
        id
        fullName
        displayName
        avatarUrl
      }
      ...CHECK_IN_REPORT_MAP_FRAGMENT
      ...CHECK_IN_REPORT_RESTRICTIONS_FRAGMENT
      ...CHECK_IN_REPORT_REQUESTS_FRAGMENT
    }
  }
`);

export const CHECK_IN_REPORT_MAP_FRAGMENT = graphql(`
  fragment CHECK_IN_REPORT_MAP_FRAGMENT on CheckInReport {
    id
    organizationId
    shortId
    cutoffAt
    placeId
    place {
      id
      name
      description
      spatialData {
        geojson
      }
      radius
    }
    organization {
      defaultMapCenter {
        latitude
        longitude
      }
      defaultMapZoom
    }
    checkInRequests {
      totalCount
      nodes {
        id
        checkInId
        checkIn {
          id
          shortId
          createdAt
          coordinates {
            x
            y
          }
        }
        member {
          id
          displayName
          fullName
          avatarUrl
        }
      }
    }
  }
`);

export const CHECK_IN_REPORT_RESTRICTIONS_FRAGMENT = graphql(`
  fragment CHECK_IN_REPORT_RESTRICTIONS_FRAGMENT on CheckInReport {
    id
    organizationId
    cutoffAt
    placeId
    place {
      id
      name
      center {
        latitude
        longitude
      }
    }
  }
`);

export const CHECK_IN_REPORT_REQUESTS_FRAGMENT = graphql(`
  fragment CHECK_IN_REPORT_REQUESTS_FRAGMENT on CheckInReport {
    id
    organizationId
    cutoffAt
    checkInRequests {
      totalCount
      nodes {
        id
        checkInId
        checkIn {
          id
          shortId
          createdAt
          coordinates {
            x
            y
          }
        }
        member {
          id
          displayName
          fullName
          avatarUrl
        }
      }
    }
  }
`);
